export const userRol = {
    'approver': {
        name: 'Admin',
        description: 'Can approve courses.',
        mobileNumber: ['9926733219','9873382826','9821587652','9212387977'],
        routes: ['/home', '/profile', '/createcourse','/addmanagevideo','/addmanagequestionnaire','/addmanageresource','/viewcourses/:courseId','/allcourses','/assigncourse','/adminsettings','/training-events','/reports','/createplan','/viewplan','/forgot-password']
    },
    'creater': {
        name: 'Course Creater',
        description: 'Can create and manage courses, videos, questionnaires, and resources.',
        mobileNumber: ['8830330139','8457011184','8429940013','8860442240'],
        routes: ['/home', '/profile', '/createcourse','/addmanagevideo','/addmanagequestionnaire','/addmanageresource','/viewcourses/:courseId','/assigncourse','/reports','/createplan','/viewplan','/forgot-password']
    },
    'viewer': {
        name: 'Learner',
        description: 'Can view courses and their details.',
        mobileNumber: [],
        routes: [ '/home', '/profile', '/viewcourses/:courseId','/forgot-password']
    },
};
export const getRollFromMobileNumber = (mobileNumber) => {
    for (const role in userRol) {
        if (userRol[role].mobileNumber.includes(mobileNumber)) {
            return role;
        }
    }
    return 'viewer'; // or a default role if needed
};
export const getDisplayNameFromRole = (role) => {
    return userRol[role]?.name;
};

export function hasRoutePermission(mobileNumber, route) {
    if (!mobileNumber || !route) {
        return false; // Invalid input
    }
    if (route === '/') {
        return true; // Allow access to the root route for all users
    }
    const roleKey = getRollFromMobileNumber(mobileNumber);

    if (!roleKey || !userRol[roleKey]) {
        return false; 
    }
    if (userRol[roleKey].routes.includes(route)) {
        return true;
    }

    const allowedRoutes = userRol[roleKey].routes  || [];
    return allowedRoutes.some(r => {
        if (r.includes(':')) {
            const regex = new RegExp('^' + r.replace(/:\w+/g, '[^/]+') + '$');
            return regex.test(route);
        }
        return r === route;
    });
}
